(() => {
  class HomeProducts extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready=true;this.loads=0;this.loading=false;this.stopped=false;
      this.grid=this.querySelector('[data-home-product-grid]');
      this.more=this.querySelector('[data-home-load-more]');
      this.status=this.querySelector('[data-home-load-status]');
      if(!this.grid||!this.more)return;
      this.events?.abort();this.events=new AbortController();
      this.cacheKey='meddey:browse:'+this.dataset.sectionId+':'+location.pathname+location.search;
      this.restore();
      this.more.addEventListener('click',event=>{event.preventDefault();this.load();},{signal:this.events.signal});
      window.addEventListener('pagehide',()=>this.save(),{signal:this.events.signal});
      if('IntersectionObserver' in window && this.dataset.autoLoad==='true') {
        this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)&&this.loads<Number(this.dataset.autoLimit||3)&&!this.stopped)this.load();},{rootMargin:'250px'});
        this.observer.observe(this.more);
      }
    }
    disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();this.events?.abort();this.ready=false;}
    label(key,fallback){return window.meddeyUIStrings?.loading?.[key]||fallback;}
    save(){
      if(!this.loads||!this.grid||!this.cacheKey)return;
      try {
        const entry=JSON.stringify({time:Date.now(),html:this.grid.innerHTML,next:this.dataset.nextUrl,loads:this.loads,y:window.scrollY});
        if(entry.length<=1000000)sessionStorage.setItem(this.cacheKey,entry);
      }catch(error){}
    }
    restore(){
      try {
        if(performance.getEntriesByType('navigation')[0]?.type!=='back_forward')return;
        const raw=sessionStorage.getItem(this.cacheKey);if(!raw||raw.length>1000000)return;
        const saved=JSON.parse(raw);
        if(Date.now()-saved.time>120000||typeof saved.html!=='string'||!Number.isInteger(saved.loads)||saved.loads<1)return;
        this.grid.innerHTML=saved.html;this.loads=saved.loads;this.dataset.nextUrl=saved.next||'';
        this.more.hidden=!this.dataset.nextUrl;if(this.dataset.nextUrl)this.more.href=this.dataset.nextUrl;
        requestAnimationFrame(()=>requestAnimationFrame(()=>window.scrollTo({top:Math.max(0,Number(saved.y)||0),behavior:'instant'})));
      }catch(error){}
    }
    async load() {
      if(this.loading||!this.dataset.nextUrl)return;
      this.loading=true;this.more.setAttribute('aria-disabled','true');this.status.textContent=this.label('loading','Loading products…');
      this.controller=new AbortController();
      try {
        const url=new URL(this.dataset.nextUrl,location.origin);
        if(url.origin!==location.origin)throw new Error('Invalid product page');
        url.searchParams.set('section_id',this.dataset.sectionId);
        const response=await fetch(url,{signal:this.controller.signal});
        if(!response.ok)throw new Error('Unable to load');
        const documentPart=new DOMParser().parseFromString(await response.text(),'text/html');
        const next=documentPart.querySelector('meddey-home-products');
        if(!next)throw new Error('Products unavailable');
        const existing=new Set(Array.from(this.grid.querySelectorAll('[data-product-id]'),node=>node.dataset.productId));
        const items=Array.from(next.querySelectorAll('[data-home-product-grid] > product-item')).filter(item=>!existing.has(item.dataset.productId));
        this.grid.append(...items);this.loads++;
        this.dataset.nextUrl=next.dataset.nextUrl||'';
        if(!this.dataset.nextUrl){this.more.hidden=true;this.observer?.disconnect();this.status.textContent=this.label('complete','All products loaded.');}
        else {this.more.href=this.dataset.nextUrl;this.more.textContent=this.label('more','View more');this.status.textContent=this.label('added','@count@ more products loaded.').replace('@count@',items.length);}
        if(this.loads>=Number(this.dataset.autoLimit||3))this.observer?.disconnect();
        document.dispatchEvent(new CustomEvent('meddey:products-loaded',{detail:{container:this.grid}}));
      } catch(error) {
        if(error.name==='AbortError')return;
        this.stopped=true;this.observer?.disconnect();this.status.textContent=this.label('error','Could not load more products. Please try again.');this.more.textContent=this.label('retry','Try again');
      } finally {this.loading=false;this.more.removeAttribute('aria-disabled');}
    }
  }
  if(!customElements.get('meddey-home-products'))customElements.define('meddey-home-products',HomeProducts);
})();
